// extracted by mini-css-extract-plugin
export default {"container":"downloadOtp_container__8aBou","logo":"downloadOtp_logo__57hSe","card":"downloadOtp_card__yvfsE"};